import { useMemo } from 'react'

import {
  getManagerCoachingRemainingSessions,
  getManagerCoachingSeatEligibility,
  type ManagerCoachingSeatEligibility,
} from '../../managerCoaching/seatEligibility'
import { type ManagerCoachingSeatState } from '../types'

const UNKNOWN_MANAGER_COACHING_SEAT_ELIGIBILITY = getManagerCoachingSeatEligibility({
  isLoading: true,
  isError: false,
})

/** App adapters own seat loading; skipped consumers receive unknown eligibility even with cached data. */
export const useManagerCoachingSeatEligibility = ({
  shouldFetchSeatEligibility,
  seatEligibility,
}: {
  shouldFetchSeatEligibility: boolean
  seatEligibility: ManagerCoachingSeatEligibility
}): ManagerCoachingSeatState => {
  const resolvedSeatEligibility = shouldFetchSeatEligibility
    ? seatEligibility
    : UNKNOWN_MANAGER_COACHING_SEAT_ELIGIBILITY

  return useMemo(
    () => ({
      seatEligibility: resolvedSeatEligibility,
      remainingSessions: getManagerCoachingRemainingSessions(resolvedSeatEligibility.license),
    }),
    [resolvedSeatEligibility],
  )
}
